import { cn } from '@/shared/utils/cn';

export interface SpinnerProps {
  size?: number;
  className?: string;
  /** Si se indica, el indicador se anuncia (role="status"); si no, es decorativo. */
  label?: string;
}

/** Anillo de carga. Con movimiento reducido queda quieto (la regla global anula la animación). */
export function Spinner({ size = 20, className, label }: SpinnerProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      className={cn('shrink-0 animate-spin', className)}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2.5" />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
